import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { EventType } from '@azure/msal-browser';
import {
  loginRequest,
  storeToken,
  b2cScopes,
  getToken,
  setLoginClick,
  getLoginClick,
  checkInterationStatus
} from '../config/msal-auth';

import { useMsal, useIsAuthenticated } from '@azure/msal-react';

import { USER_URL } from '../api/endpoints';
import { apiRequest, resetApiStatus } from '../api/actions';
import { logout, setUser } from './actions';
import useToast from '../components/Toast/useToast';
import { API_REQUEST } from '../api/action-types';

const getUser = state => {
  return state.containers.app.get('user');
};

const useAuth = (autoNavigate = true) => {
  let { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const user = useSelector(getUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [openSnackbar] = useToast();

  // console.log('isAuthenticated', isAuthenticated);
  // console.log('accounts', accounts);
  // console.log('inProgress', inProgress);
  // console.log('user', user);

  instance.addEventCallback(event => {
    if (
      event.eventType === EventType.LOGIN_START ||
      (event.eventType !== EventType.LOGIN_SUCCESS && getLoginClick() == 'true')
    ) {
      if (location.pathname !== 'questionarie')
        dispatch({ type: API_REQUEST, meta: { ignoreSuccessReset: true } });
    } else if (event.eventType === EventType.LOGIN_FAILURE) {
      setLoginClick(false);
    }
  });

  const onUserSuccess = result => {
    if (Object.keys(result.data?.data).length > 0) {
      dispatch(setUser(result.data.data));
      if (location.pathname === '/' || location.pathname === '/questionarie') {
        navigate('/landing/assessments', { replace: true });
      }
    } else {
      openSnackbar(result.data.message);
      setTimeout(() => {
        b2cLogout();
      }, 5000);
    }
  };

  const onUserError = error => {
    if (error === 'Invalid login') {
      b2cLogout();
    }
  };

  const fetchUser = () => {
    const request = {
      url: USER_URL,
      method: 'get'
    };

    const meta = {
      onSuccess: onUserSuccess,
      onError: onUserError
    };

    dispatch(apiRequest(request, meta));
  };

  const onLoginSuccess = (res, from) => {
    dispatch({ type: API_REQUEST, meta: { ignoreSuccessReset: true } });
    if (res && res.accessToken && res.accessToken !== '') {
      storeToken(res.accessToken);
    }
    fetchUser();
  };

  const b2cLogin = () => {
    localStorage.clear(); // clear local storage before login , so that user session will clear
    setLoginClick(true);
    dispatch({ type: API_REQUEST, meta: { ignoreSuccessReset: true } });
    instance
      .loginRedirect(loginRequest)
      .then(onLoginSuccess)
      .catch(err => console.log(err));
  };

  const b2cLogout = () => {
    const logoutRequest = {
      account: accounts[0]
    };

    dispatch(setUser(null));
    dispatch(logout());
    sessionStorage.clear();
    localStorage.clear();
    setLoginClick(true);
    instance.logoutRedirect(logoutRequest).catch(e => {
      console.error(e);
    });
  };

  useEffect(() => {
    if (accounts && accounts.length >= 1)
      dispatch({ type: API_REQUEST, meta: { ignoreSuccessReset: true } });
    if (inProgress != 'logout' && (!getToken() || !checkInterationStatus())) {
      selectAccount();
    } else if (getToken()) {
      fetchUser();
    }
  }, [inProgress]);

  const selectAccount = () => {
    if (accounts.length === 0) {
      return;
    } else if (accounts.length > 1) {
      // Add your account choosing logic here
      console.log('Multiple accounts detected.');
      const originalSignInAccount = instance
        .getAllAccounts()
        .find(
          account => account?.idTokenClaims['tfp'] === 'B2C_1_signIn'
        );

      instance
        .acquireTokenSilent({
          account: instance.getAccountByHomeId(
            originalSignInAccount.homeAccountId
          ),
          scopes: b2cScopes
        })
        .then(response => {
          // storeToken(response.accessToken)
          onLoginSuccess(response);
        })
        .catch(e => {
          dispatch(resetApiStatus());
        });
    } else if (accounts.length === 1) {
      /**
       * In order to obtain the ID Token in the cached obtained previously, you can initiate a
       * silent token request by passing the current user's account and the scope "openid".
       */
      instance
        .acquireTokenSilent({
          account: instance.getAccountByHomeId(accounts[0].homeAccountId),
          scopes: b2cScopes
        })
        .then(response => {
          // move to respective
          onLoginSuccess(response);
        })
        .catch(e => {
          dispatch(resetApiStatus());
        });
    }
  };

  return { isAuthenticated, user, b2cLogin, b2cLogout };
};

export default useAuth;
